import axios from "axios";
import { ADMIN_API_URL } from "../config/serviceConstant";

export const upsertSetting = async ({ headers, data }) => {
  try {
    const config = {
      method: "POST",
      url: ADMIN_API_URL + "/db/planetscale/clients/settings",
      headers: headers,
      data: data,
    };

    const upsertSettingResp = await axios(config);
    console.log({ upsertSettingResp: upsertSettingResp?.data });
    return upsertSettingResp?.data;
  } catch (error) {
    return null;
  }
};

export const getSettingById = async ({ headers, settingId }) => {
  try {
    const config = {
      method: "get",
      url: ADMIN_API_URL + "/db/planetscale/clients/settings/" + settingId,
      headers: headers,
    };

    const getSettingResp = await axios(config);
    console.log({ getSettingResp: getSettingResp?.data });
    return getSettingResp?.data;
  } catch (error) {
    return null;
  }
};

export const getSettings = async ({ headers, params }) => {
  try {
    const config = {
      method: "get",
      url: ADMIN_API_URL + "/db/planetscale/clients/settings",
      headers: headers,
      params: params,
    };

    const getSettingsResp = await axios(config);
    console.log({ getSettingsResp: getSettingsResp?.data });
    return getSettingsResp?.data;
  } catch (error) {
    return null;
  }
};

export const deleteSettingById = async ({ headers, settingId }) => {
  try {
    const config = {
      method: "delete",
      url: ADMIN_API_URL + "/db/planetscale/clients/settings/" + settingId,
      headers: headers,
    };

    const getSettingResp = await axios(config);
    console.log({ getSettingResp: getSettingResp?.data });
    return getSettingResp?.data;
  } catch (error) {
    return null;
  }
};